import type { Taxon } from '../generated/graphql'
import { taxonCodeEqualsGenre } from './taxon-code-equals-genre'

export function filterByTaxonCodeGenre(taxa: Taxon[]) {
  return taxa.filter((taxon) => taxonCodeEqualsGenre(taxon))
}
